<template>
  <div class="bg-img__color">
    <b-navbar
        toggleable="lg"
        type="light"
        fixed="top"
        :style="navStyles"
    >
      <div class="container justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <router-link :to="{ name: 'home' }" class="me-2">
            <img
                v-if="scrollPosition < 50"
                class="navbar-logo"
                src="../assets/images/logo.png"
                alt="Logo"
            />
            <img
                v-else
                class="navbar-logo"
                src="../assets/images/black-logo.png"
                alt="Logo black"
            />
          </router-link>

          <a
              :href="`tel: ${CALL_CENTER_PHONE_NUMBER}`"
              :class="`d-none d-md-block text-decoration-none ${scrollPosition < 50 ? 'text-white' : 'text-black'}`"
              style="font-weight: 500; font-size: 18px;"
          >
            &nbsp;|&nbsp; {{ CALL_CENTER_PHONE_NUMBER }}
          </a>
        </div>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav right>
          <b-navbar-nav class="ml-auto d-flex align-items-center" right>
            <router-link
                v-for="(link, index) in links"
                :key="'navbar link' + index"
                class="navbar-item"
                :to="{ name: link.name, hash: link.hash }"
            >
              <span :class="{ changed: scrollPosition > 50 }">
                {{ $t(`site_links.${link.title || link.name}`) }}
              </span>
            </router-link>

            <TheLangPicker :scroll-position="scrollPosition" />

            <UserAccessibility class="me-2 d-xl-block d-none" :is-black="scrollPosition > 50" />

          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import navLinks from '@/mixins/nav-links.mixin';
import TheLangPicker from '@/components/TheLangPicker';
import UserAccessibility from '@/components/UserAccessibility';
import { CALL_CENTER_PHONE_NUMBER } from '@/utils/constants';

export default {
  name: 'Navbar',
  data() {
    return {
      scrollPosition: null,
      CALL_CENTER_PHONE_NUMBER,
    };
  },
  components: {
    TheLangPicker,
    UserAccessibility,
  },
  computed: {
    navStyles() {
      return this.scrollPosition > 50 ? { backgroundColor: 'white', color: 'black' } : {
        backgroundColor: 'transparent',
        color: 'white',
      };
    },
  },
  mixins: [navLinks],
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.scrollY;
    });
  },
};
</script>

<style scoped lang="scss">
.navbar {
  @media (max-width: 576px) {
    background-color: $main;
  }

  &-nav {
    @media (max-width: 576px) {
      a {
        color: $white !important;
        padding: 10px 0;
        text-align: left;
      }

      .router-link-active {
        color: $black;
      }
    }
  }

  &-item {
    color: $white;
    text-decoration: none;
    list-style-type: none;
    margin-right: 24px;

    @media (max-width: 1366px) {
      margin-right: 16px;
    }

    a {
      text-decoration: none;
      color: $white;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &-logo {
    margin-left: 0;
    padding-left: 0;
  }

  &-collapse {
    flex-grow: 0;
  }
}

.bg-img__color {
  background-size: cover;
}

.changed {
  color: $black;
}

@media (max-width: $mobile) {
  .navbar-toggler {
    border: none !important;
  }
}
</style>